export const BUSINESS_PLAN_SECTION_KEYS = [
  "executive_summary",
  "company_overview",
  "market_opportunity",
  "product_and_service",
  "traction_and_customers",
  "revenue_model",
  "financial_projections",
  "expense_structure",
  "team",
  "milestones_and_roadmap",
  "funding_requirements",
  "risk_factors",
] as const;

export type BusinessPlanSectionKey = (typeof BUSINESS_PLAN_SECTION_KEYS)[number];

export const BUSINESS_PLAN_SECTION_LABELS: Record<BusinessPlanSectionKey, string> = {
  executive_summary: "Executive Summary",
  company_overview: "Company Overview",
  market_opportunity: "Market Opportunity",
  product_and_service: "Product & Service",
  traction_and_customers: "Traction & Customers",
  revenue_model: "Revenue Model",
  financial_projections: "Financial Projections",
  expense_structure: "Expense Structure",
  team: "Team",
  milestones_and_roadmap: "Milestones & Roadmap",
  funding_requirements: "Funding Requirements",
  risk_factors: "Risk Factors",
};

export const BUSINESS_PLAN_SECTION_HINTS: Partial<Record<BusinessPlanSectionKey, string>> = {
  executive_summary: "One-page overview: problem, solution, traction, ask.",
  market_opportunity: "TAM/SAM/SOM if known; otherwise describe the market you are pursuing.",
  financial_projections: "Reference your runway and growth assumptions in plain language.",
  team: "List founders and key hires in Team roster (Investor portal). Bios appear in the plan automatically.",
  milestones_and_roadmap:
    "Past milestones and next 12–24 months. Required if you have not added timeline events yet.",
  funding_requirements: "How much you are raising and what it unlocks.",
};
